import { getJSON, STORE_HOST, getHrefParam, post } from './ultile';
import globalConfig from '@utiles/officialStore/globalConfig';
import {
  getGlobalGetGotoLink,
  getGlobalGetLinkParams
} from '@utiles/globalGetLink';
import { gameIdTransform } from '@utiles/officialTopupNew/transform';
export const INIT_USER_PAY_TYPE_INFOS = 'initUserPayTypeInfos';
export const SET_ACTIVE_PAYWAY = 'setActivePayway';
export const TOGGLE_SAVE_PAYWAY = 'toggleSavePayway';
export const SET_LANG_POPUP = 'setLangPopup';
export const PAYMENT_REQUEST_ACTION = 'paymentRequestAction';
export const DELETE_PAY_TYPE_ACTION = 'deletePayTypeAction';
export const SWITCH_LANGUAGE = 'switchLanguage';
export const CANCEL_ORDER = 'cancelOrder';
export const UPDATE_CASH_PARAMS = 'updateCashParams';
export const CLEAR_CASH_PARAMS = 'clearCashParams';
const PAYMENT_REQUEST = 'payment_request';
const GET_PAY_TYPE_INFOS = 'get_user_pay_type_infos';
const SET_USER_PAY_TYPE_INFOS = 'set_user_pay_type_infos';
const DELETE_PAY_TYPE = 'del_user_pay_type_infos';
const DELETE_PAY_TYPE_WORLD_PAY = 'world_pay/del_user_pay_type_infos';
export const handleBeforeUnload = () => {
  window.webstorev35DataLayer.push({
    eventName: 'show_popup',
    eventType: 'leave_page_confirm_popup'
  });
};
export default {
  state: {
    currency: '',
    pay_type: '',
    order_id: '',
    f_pay_type: '',
    config_key: '',
    card_scheme: '',
    product_desc: '',
    amount: '',
    active_payway: '',
    user_pay_infos: [],
    save_payway: false,
    redirect_url: '',
    langPopupState: false
  },
  mutations: {
    [UPDATE_CASH_PARAMS](state, data) {
      state.currency = data.currency;
      state.pay_type = data.pay_type;
      state.order_id = data.order_id;
      state.f_pay_type = data.f_pay_type;
      state.config_key = data.config_key;
      state.card_scheme = data.card_scheme;
      state.product_desc = data.product_desc;
      state.amount = data.amount;
    },
    [CLEAR_CASH_PARAMS](state) {
      state.currency = '';
      state.pay_type = '';
      state.order_id = '';
      state.f_pay_type = '';
      state.config_key = '';
      state.card_scheme = '';
      state.product_desc = '';
      state.amount = '';
    },
    [SET_USER_PAY_TYPE_INFOS](state, data) {
      state.user_pay_infos = data;
    },
    [SET_ACTIVE_PAYWAY](state, data) {
      state.active_payway = data;
    },
    [TOGGLE_SAVE_PAYWAY](state) {
      state.save_payway = !state.save_payway;
    },
    [SET_LANG_POPUP](state, langState) {
      state.langPopupState = langState;
    },
    [CANCEL_ORDER](state, msg = '') {
      window.location.href = `https://gstore.${globalConfig.getMainHost()}/${state.f_pay_type
        }/online_callback?order_id=${state.order_id
        }&type=cancel&status=cancel&language=${state.lang}&appLanguage=${state.lang
        }${msg.length ? '&msg=' + msg : ''}`;
    }
  },
  getters: {
    isCKO(state) {
      return state.f_pay_type === 'checkout';
    },
    isWPOrAliPay(state) {
      return state.f_pay_type === 'world_pay' || (state.f_pay_type === 'alipay' && state.pay_type && state.pay_type.toLowerCase().indexOf('card') === 0);
    },
    isSandBox(state) {
      return state.config_key === 'sandbox';
    },
    getMoneyWithUnit(state) {
      return (+state.amount).toLocaleString(state.lang) + ' ' + state.currency;
    },
    hidePageView(state) {
      return (
        state.user_pay_infos.length === 0 && (state.f_pay_type === 'world_pay' || (state.f_pay_type === 'alipay' && state.pay_type && state.pay_type.toLowerCase().indexOf('card') === 0))
      );
    }
  },
  actions: {
    [INIT_USER_PAY_TYPE_INFOS]({ commit, state, dispatch }) {
      const mainHost = globalConfig.getMainHost();
      if (
        !state.order_id.length &&
        !state.currency.length &&
        !state.amount.length
      ) {
        window.location.href = `https://pay.${mainHost}/platform/login.html?forward=${encodeURIComponent(
          getGlobalGetGotoLink({ link: window.location.href })
        )}`;
      }
      const data = {
        f_pay_type: state.f_pay_type,
        pay_type: state.pay_type,
        currency: state.currency
      };
      return new Promise((resolve, reject) => {
        getJSON(STORE_HOST + GET_PAY_TYPE_INFOS, data).then(
          ({ errmsg, res }) => {
            if (errmsg && +res.result == 0) {
              reject({ message: errmsg });
              window.location.href = `https://pay.${mainHost}/platform/login.html?forward=${encodeURIComponent(
                getGlobalGetGotoLink({ link: window.location.href })
              )}`;
              return;
            }
            commit(SET_USER_PAY_TYPE_INFOS, res.data);
            commit(
              SET_ACTIVE_PAYWAY,
              res.data.length ? state.user_pay_infos[0].KEY_VALUE : 'addCard'
            );
            // worldPay + 无卡支付 = 直接触发支付提交
            if (!res.data.length && (state.f_pay_type === 'world_pay' || (state.f_pay_type === 'alipay' && state.pay_type && state.pay_type.toLowerCase().indexOf('card') === 0))) {
              dispatch(PAYMENT_REQUEST_ACTION, {});
              resolve(false);
              return;
            }
            resolve(true);
          }
        );
      });
    },
    [PAYMENT_REQUEST_ACTION]({ state, commit }, data) {
      window.webstorev35DataLayer.push({
        eventName: 'click_button',
        eventType: 'click_submit_btn'
      });
      const _uploadData = {
        product_currency: state.currency,
        product_money: state.amount,
        f_pay_type: state.f_pay_type,
        credit_type: state.card_scheme,
        pay_type: state.pay_type,
        order_id: state.order_id,
        product_desc: state.product_desc,
        active_payway: state.active_payway,
        save_payway: state.save_payway
      };
      const newData = Object.assign(
        {
          order_id: state.order_id,
          appLanguage: state.lang,
          language: state.lang,
          store: state.save_payway ? 1 : 0,
          ...getGlobalGetLinkParams()
        },
        data
      );
      // WP不需要store参数
      if (state.f_pay_type === 'world_pay' || (state.f_pay_type === 'alipay' && state.pay_type && state.pay_type.toLowerCase().indexOf('card') === 0)) {
        delete newData.store;
      }
      return new Promise((resolve, _reject) => {
        post(STORE_HOST + state.f_pay_type + '/' + PAYMENT_REQUEST, gameIdTransform(newData), {
          withCredentials: true
        }).then(({ errmsg, res }) => {
          if (errmsg) {
            window.webstorev35DataLayer.push({
              eventName: 'submit_credit_pay',
              eventValue: Object.assign(
                {
                  eventResult: 'failed'
                },
                _uploadData
              )
            });
            // 亨哲：当result=0而且有msg的时候，把这个msg也带到返回储值结果页的参数里面
            const passMsg =
              res?.data?.result == 0 ? encodeURIComponent(errmsg) : '';
            commit(CANCEL_ORDER, passMsg);
            resolve({ message: errmsg });
          } else {
            window.webstorev35DataLayer.push({
              eventName: 'submit_credit_pay',
              eventValue: Object.assign(
                {
                  eventResult: 'success'
                },
                _uploadData
              )
            });
            window.location.href = res.data.redirect_url;
          }
        });
      });
    },
    [DELETE_PAY_TYPE_ACTION]({ state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        const reqPath =
          state.f_pay_type === 'world_pay'
            ? DELETE_PAY_TYPE_WORLD_PAY
            : DELETE_PAY_TYPE;
        getJSON(
          STORE_HOST + reqPath,
          Object.assign(
            {
              f_pay_type: state.f_pay_type,
              pay_type: state.pay_type,
              currency: state.currency
            },
            data
          )
        ).then(({ errmsg, res }) => {
          if (errmsg) {
            reject({ message: errmsg });
          } else {
            dispatch(INIT_USER_PAY_TYPE_INFOS);
            resolve(res);
          }
        });
      });
    }
  }
};
